import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { PortalOrderService } from '@app/services/portal-order/portal-order.service';
import { PortalSalesAgentNode, AncillaryUpsellNode } from '@app/services/api/api.types';
import { Tracking } from '@app/services/tracking/tracking.service';
import { PortalTrackingEvents } from '@app/utils/tracking-events';
import { PortalLeadService } from '@app/services/portal-lead/portal-lead.service';
import { StateService } from '@app/services/state/state.service';

@Component({
  selector: 'complete-page',
  templateUrl: './complete-page.component.html',
  styleUrl: './complete-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompletePageComponent implements OnInit {
  portalOrderService = inject(PortalOrderService);
  portalLeadService = inject(PortalLeadService);
  stateService = inject(StateService);

  salesAgent?: PortalSalesAgentNode;
  isGratuityOnly: boolean;

  ngOnInit() {
    Tracking.track(PortalTrackingEvents.ancillaryUpsellSuccessPageOpened);

    const isPerpetual = this.stateService.getState().perpetual;

    const portalOrder = this.portalOrderService.portalOrder$$
      .value as unknown as AncillaryUpsellNode;

    const portalLead = this.portalLeadService.portalLead$$.value;

    this.salesAgent = portalOrder?.salesAgent || portalLead?.salesAgent;

    const isGratuity = portalOrder?.showGratuity && !portalOrder?.ancillaries?.length;

    if (isPerpetual || isGratuity) {
      this.isGratuityOnly = true;
    }
  }
}
